import { registerAction } from '../../Action'

const TOGGLE_GLOBAL_SEARCH = 'TOGGLE_GLOBAL_SEARCH'

const reducer = (state = {}, action) => {
  let globalSearchIsVisible = false
  if (action.payload) globalSearchIsVisible = action.payload

  return {
    ...state,
    globalSearchIsVisible,
  }
}

const toggleGlobalSearch = registerAction(TOGGLE_GLOBAL_SEARCH, { reducer })
export default toggleGlobalSearch
